









import Card from '../BaseCard.vue'
import CardContent from '../BaseCardContent.vue'
import Checkbox from '../BaseCheckbox.vue'

export default {
  components: { Card, CardContent, Checkbox },
  props: { makeRecurring: Boolean }
}
